import { render } from "./productPrice.vue?vue&type=template&id=2ff55828"
import script from "./productPrice.vue?vue&type=script&lang=js"
export * from "./productPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__